import { PageProps, graphql, useStaticQuery } from "gatsby";
import React, { FC, ReactNode, createContext, useContext } from "react";

const query = graphql`
  query Cms {
    allMicrocmsArticle(sort: { createdAt: DESC }) {
      edges {
        node {
          id
          title
          content
          url
          suburl
          subtitle
          cost
          tag {
            name
          }
          image {
            url
          }
          category
          publishedAt(formatString: "YYYY-MM-DD")
          updatedAt(formatString: "YYYY-MM-DD")
        }
      }
    }
    allMicrocmsTag {
      edges {
        node {
          name
          category
        }
      }
    }
  }
`;

const defaultState: Queries.CmsQuery = {
  allMicrocmsArticle: {
    edges: [],
  },
  allMicrocmsTag: {
    edges: [],
  },
};

const CmsContext = createContext(defaultState);

const CmsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const cmsData = useStaticQuery<Queries.CmsQuery>(query);
  const value = cmsData;
  return <CmsContext.Provider value={value}>{children}</CmsContext.Provider>;
};

export function useCmsContext() {
  return useContext(CmsContext);
}

export default CmsProvider;
